import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Préparer chaque entraînement vous demande énormément de temps',
  lines: ['Chaque semaine, vous passez des heures à préparer vos séances.', 'Vous cherchez de nouveaux exercices.', 'Vous créez des progressions.', 'Vous organisez les ateliers.', "Vous adaptez les exercices selon l'âge et le niveau.", 'Vous préparez les échauffements.', 'Vous planifiez les rotations sur les agrès.', 'Au final, préparer vos entraînements prend presque autant de temps que les donner.']
}, {
  emoji: '⚠️',
  title: 'Vous ne savez pas toujours quoi proposer ensuite',
  lines: ['Vous vous posez constamment les mêmes questions :', "Quel exercice vais-je faire aujourd'hui ?", 'Quelle est la prochaine progression ?', 'Comment faire progresser chaque gymnaste à son rythme ?', 'Comment gérer plusieurs niveaux dans le même groupe ?', 'Construire des séances variées, progressives et motivantes devient un véritable défi semaine après semaine.']
}, {
  emoji: '📚',
  title: 'Vos ressources sont dispersées partout',
  lines: ['Exercices.', 'Progressions.', 'Échauffements.', 'Situations pédagogiques.', 'Séances.', 'Évaluations.', 'Documents.', 'Tout existe...', 'Mais tout est dispersé entre des livres, des formations, des PDF, des vidéos YouTube et des dizaines de dossiers sur votre ordinateur.', "Rien n'est réellement organisé dans un système unique, simple et prêt à être utilisé."]
}, {
  emoji: '😩',
  title: 'La préparation devient épuisante',
  lines: ['Entre la préparation des séances...', "L'organisation des groupes...", 'Les progressions techniques...', 'La gestion des agrès...', 'Le suivi des gymnastes...', 'Les évaluations...', 'La planification de la saison...', 'Il reste finalement très peu de temps pour ce qui compte vraiment :', 'Faire progresser vos élèves, développer leur confiance et transmettre votre passion de la gymnastique artistique.']
}];
export function PainSection() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-ivory" data-id="element-106">
      <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-center text-brand-navy mb-2 uppercase leading-tight" data-id="element-107">
        VOUS VOUS RECONNAISSEZ ?
      </h2>
      <p className="text-sm sm:text-base text-brand-text font-medium text-center mb-4 leading-snug max-w-xl mx-auto" data-id="element-108">
        Vous aimez enseigner la gymnastique artistique.
        <br data-id="element-109" />
        Mais préparer chaque entraînement finit par vous prendre une grande
        partie de votre semaine.
        <br data-id="element-110" />
        <span className="text-brand-violet font-bold mt-1 block" data-id="element-111">
          Que vous enseigniez dans un club, une association sportive, une école,
          une académie ou en cours particuliers, vous avez probablement déjà
          vécu au moins l'une de ces situations.
        </span>
      </p>
      <div className="flex flex-col gap-2.5" data-id="element-112">
        {pains.map(pain => <article key={pain.title} className="bg-white p-3.5 rounded-lg border-l-4 border-brand-violet shadow-sm flex gap-3 items-start" data-id="element-113">
            <div className="text-xl leading-none shrink-0 mt-0.5" data-id="element-114">
              {pain.emoji}
            </div>
            <div data-id="element-115">
              <h3 className="text-sm sm:text-base font-heading font-bold text-brand-navy mb-1.5 uppercase tracking-tight leading-tight" data-id="element-116">
                {pain.title}
              </h3>
              <div className="text-brand-text text-sm font-medium leading-snug space-y-0.5" data-id="element-117">
                {pain.lines.map(line => <p key={line} data-id="element-118">{line}</p>)}
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}